'use client'

import { useMutation } from '@tanstack/react-query'
import { useCallback } from 'react'
import { calcProductShippingService } from '@/services/domain/catalog/ProductShippingService'
import { useProductStore } from '@/stores/useProductStore'

interface ICalculateOverrides {
    productId?: string
    quantity?: number
}

/**
 * Frete na PDP. `calculate(cep)` usa o produto aberto e a quantidade da `useProductStore`; produto e quantidade podem
 * ser informados. O erro da API já sai no toast do service; a promessa rejeita para o formulário reagir.
 */
export function useProductShipping() {
    const mutation = useMutation({ mutationFn: calcProductShippingService })
    const { mutateAsync } = mutation

    const calculate = useCallback(
        async (zipcode: string, overrides: ICalculateOverrides = {}) => {
            const { currentProduct, quantity } = useProductStore.getState()
            const productId = overrides.productId ?? currentProduct?.id
            if (!productId) throw new Error('Nenhum produto para calcular o frete.')
            return mutateAsync({ zipcode, productId, quantity: overrides.quantity ?? quantity })
        },
        [mutateAsync],
    )

    return {
        quotes: mutation.data ?? [],
        calculate,
        isCalculating: mutation.isPending,
        isError: mutation.isError,
        reset: mutation.reset,
    }
}
